import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';

import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

const getInitialLanguage = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/get-user-language/`);
    return response.data.language;
  } catch (error) {
    console.error('Error fetching initial language:', error);
    return 'en';
  }
};

const i18nInstance = i18n.createInstance();

i18nInstance
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

getInitialLanguage().then(language => {
  i18nInstance.changeLanguage(language);
});

export default i18nInstance;